import { render, staticRenderFns } from "./errorpage.vue?vue&type=template&id=05c62389&scoped=true&"
import script from "./errorpage.vue?vue&type=script&lang=js&"
export * from "./errorpage.vue?vue&type=script&lang=js&"
import style0 from "./errorpage.vue?vue&type=style&index=0&id=05c62389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c62389",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c62389')) {
      api.createRecord('05c62389', component.options)
    } else {
      api.reload('05c62389', component.options)
    }
    module.hot.accept("./errorpage.vue?vue&type=template&id=05c62389&scoped=true&", function () {
      api.rerender('05c62389', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pub/components/errorpage.vue"
export default component.exports